<template>
  <div class="mdl-card fill mdl-shadow--2dp">
    <div class="ga-form-title">
      <h2 class="ga-title-text">{{'newScheduled.label.title' | label}}</h2>
    </div>
    <div class="mdl-card__supporting-text">
      <validator name="newScheduledValidator">
        <form novalidate>
          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
            <input class="mdl-textfield__input" type="text" id="recipients" initial="off" v-model="message['message']['recipients']" v-validate:recipients="['emailArray']">
            <label class="mdl-textfield__label ga-required" for="recipients">{{'newScheduled.label.recipients' | label}}</label>
            <span class="validation-error mdl-textfield__error" v-if="$newScheduledValidator.recipients.emailArray">{{'newScheduled.validation.recipients' | label}}</span>
            <span class="ga-input-instruction" v-if="!$newScheduledValidator.recipients.emailArray">{{'newScheduled.instruction.recipients' | label}}</span>
          </div>
          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
            <input class="mdl-textfield__input" type="text" id="subject" v-model="message['message']['subject']" initial="off" v-validate:subject="['required']">
            <label class="mdl-textfield__label ga-required" for="subject">{{'newScheduled.label.subject' | label}}</label>
            <span class="validation-error mdl-textfield__error" v-if="$newScheduledValidator.subject.required">{{'general.validation.required' | label}}</span>
            <span class="ga-input-instruction" v-if="!$newScheduledValidator.subject.required">{{'newScheduled.instruction.subject' | label}}</span>
          </div>
          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
          <text-area :body.sync=message['message']['messageBody'] :placeholder="getLabel('newScheduled.label.messageBody')" component-id="newscheduled">
          </text-area>
          <input v-show="false" class="mdl-textfield__input" type="text" id="messageBody" initial="off" v-model="message['message']['messageBody']" v-validate:messageBody="['required']">
          <span class="validation-error mdl-textfield__error" v-if="$newScheduledValidator.messagebody.required">{{'newScheduled.validation.messageBody' | label}}</span>
          <span class="ga-input-instruction" v-if="!$newScheduledValidator.messagebody.required">{{'newScheduled.instruction.messagebody' | label}}</span>
          <!--</div>-->
          <div class="mdl-grid inner-grid">
            <!--<div class="mdl-cell mdl-cell&#45;&#45;6-col">-->
              <label class="delivery-label ga-required">{{'newScheduled.label.deliveryDate' | label}}</label>
          </div>
          <div class="mdl-grid inner-grid fill">
            <!--<div class="mdl-cell mdl-cell&#45;&#45;6-col">-->
              <datepicker :time.once="message['messageSendingDate']" :out.sync="message['messageSendingDate']" type="min" :format="messageSendingDateFormat" :limit="limit">
                <input v-show="false" class="mdl-textfield__input" type="text" id="messageSendingDate" initial="off" v-model="message['messageSendingDate']" v-validate:messageSendingDate="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$newScheduledValidator.messagesendingdate.required">{{'newScheduled.validation.messageSendingDate' | label}}</span>
                <span class="ga-input-instruction" v-if="!$newScheduledValidator.messagesendingdate.required">{{'newScheduled.instruction.messagesendingdate' | label}}</span>
              </datepicker>
            <!--</div>-->
          </div>
          <!--<div class="mdl-grid inner-grid">-->
            <!--<div class="mdl-cell mdl-cell&#45;&#45;10-col">-->
              <!--<div v-el:attachment class="attachment-label">{{attachmentsLabel}}-->
                <!--<attachment v-for="attachment in message['message']['attachments']" :file.sync=attachment :attachments.sync=message['message']['attachments']></attachment>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="mdl-cell mdl-cell&#45;&#45;2-col">-->
              <!--<div v-el:addAttachment v-on:click="addAttachment()" class="mdl-button mdl-js-button mdl-button&#45;&#45;fab mdl-button&#45;&#45;mini-fab" value="">-->
                <!--<i class="material-icons">add</i>-->
              <!--</div>-->
              <!--<input class="display-none" v-el:file type="file" v-on:change="uploadFile()" multiple/>-->
            <!--</div>-->
            <!--<span class="ga-input-instruction">{{'newScheduled.instruction.attachments' | label}}</span>-->
          <!--</div>-->
        </form>
      </validator>
    </div>
    <div class="mdl-card__actions">
      <div class="card-grid mdl-grid">
        <div class="mdl-cell mdl-cell--8-col">
        </div>
        <div class="mdl-cell mdl-cell--4-col">
          <button v-el:saveButton class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored float-right"
                  v-on:click="validate()">
            {{'newScheduled.button.next' | label}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var file = require('api/File')
  var label = require('vue').filter('label')
  var appConfig = require('vue').filter('appConfig')
  var moment = require('moment-timezone')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
    },
    components: {
      'mdl-select': require('c/components/Select'),
      'datepicker': require('c/components/Datepicker'),
      'attachment': require('c/components/Attachment'),
      registerForm: require('c/forms/RegisterForm'),
      'text-area': require('c/components/TextArea')
    },
    methods: {
      validate: function () {
        var self = this
        if (self.uploading) {
          return
        }
        this.$validate(true, function () {
          if (self.$newScheduledValidator.invalid) {
            return
          }
          self.$dispatch('message-valid', self.message)
        })
      },
      uploadFile: function () {
        var self = this
        var files = this.$els.file.files
        var fileTypes = appConfig('fileTypes')
        // var maxMessageSize = appConfig('maxMessageSize')
        var maxFileSize = appConfig('maxFileSize')
        Object.keys(files).forEach(function (i) {
          if (fileTypes.indexOf(files[i].type) === -1) {
            return
          }
          if (files[i].size > maxFileSize) {
            self.$dispatch('show-error', new Error(label('newScheduled.validation.attachments.maxFileSize')))
            return
          }
          // not needed anymore: any attachment becomes a link
          // if (self.totalAttachmentSize + files[i].size > maxMessageSize) {
          //   self.$dispatch('show-error', new Error(label('newScheduled.validation.attachments.maxSize')))
          //   return
          // }
          var f = files[i]
          var attachment = {
            'fileName': f.name,
            'fileSize': f.size,
            'contentType': f.type
          }
          self.message.message.attachments.push(attachment)
          self.uploading = true
          file.uploadFile(files[i], function (response) {
            f.index = self.message.message.attachments.length
            var sendAsLink = false
            if ((f.type).startsWith('video')) {
              sendAsLink = true
            }
            // all attachments must be a link
            sendAsLink = true
            attachment.s3Key = response.data.Key
            attachment.sendAsLink = sendAsLink
            attachment.__finished = true
            self.$broadcast('refresh')
            self.uploading = false
          }, function (err) {
            attachment.__finished = true
            self.$broadcast('refresh')
            self.$dispatch('show-error', err)
            self.uploading = false
          })
        })
      },
      clearFileInput: function () {
        this.$els.file.value = ''
      },
      getLabel: function (key) {
        return label(key)
      },
      addAttachment: function () {
        var self = this
        if (!self.uploading) {
          self.clearFileInput()
          self.$els.file.click()
        }
      }
    },
    data: function () {
      return {
        message: {
          message: {
            recipients: '',
            subject: '',
            messageBody: '',
            attachments: []
          },
          messageSendingDate: '',
          status: 'SCHEDULED',
          serviceCode: 'SCHEDULED'
        },
        attachmentsLabel: 'Attachments',
        starttime: '',
        messageSendingDateFormat: 'LLLL',
        uploading: false
      }
    },
    events: {
      'remove-file': function (f) {
        var self = this
        file.remove(f.s3Key, function (response) {
        }, function (err) {
          self.$dispatch('show-error', err)
        })
      }
    },
    computed: {
      totalAttachmentSize: function () {
        var result = 0
        this.message.message.attachments.forEach(function (attachment) {
          result += attachment.size
        })
        return result
      },
      defaultTimeZone: function () {
//        var moment = require('moment-timezone')
//        console.log('?' + appConfig('maxScheduledDays'))
        return moment.tz.guess()
      },
      limit: function () {
        var moment = require('moment-timezone')
        var from = moment().subtract(1, 'days')
        var to = moment().add(appConfig('maxScheduledDays'), 'day')// appConfig(maxScheduledDays)
        return [{
          type: 'fromto',
          from: from,
          to: to
        }]
      }
    },
    watch: {
      'uploading': function (newVal, oldlVal) {
        var self = this
        var button = self.$els.savebutton
        if (newVal) {
          button.classList.add('gray')
        } else {
          button.classList.remove('gray')
        }
      }
    }
  }
</script>

<style scoped>
  .scheduled-card {
    width: 100%;
  }
  .gray {
    background-color: rgba(190,190,190,.2) !important;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// ScheduledMessageForm.vue?778a9c31